export const TABS_OPTIONS = [
  { label: 'Health System details', value: 'general' },
  { label: 'Hospitals', value: 'hospitals' },
  { label: 'Users', value: 'users' },
  { label: 'Banking setup', value: 'banking_setup' },
  { label: 'Bank accounts', value: 'bank_accounts' }
]

export const TABS_OPTIONS_KEY = {
  general: 'general',
  hospitals: 'hospitals',
  users: 'users',
  banking_setup: 'banking_setup',
  bank_accounts: 'bank_accounts'
}
